<template>
  <div class="row no-gutters" v-if="produtos">
    <div class="col-sm-6 col-md-4 col-lg-3 col-xl-2 px-sm-1" v-for="(l,i) in produtos" :key="l.id_produto">
      <div class="lista shadow-sm">
        <a href="javascript:" :id="`listaProd${i}`" class="lista-body" @click="adicionarProduto(l)">
          <div class="lista-img" :class="{'bg-none': !!l.url_imagem}">
            <img :src="l.url_imagem ? l.url_imagem : base_cdn + '/lecard-corporativo/static/imgs/default.png'" aria-hidden="true">
          </div>
          <div class="lista-valor">
            <div class="badge badge-light border" v-if="l.valor > 0">
              <span v-if="l.qtd_tabelas > 1 && l.valor > 0" style="font-size: 9px">A partir</span> {{l.valor | valor}}
            </div>
            <div class="d-none d-md-block" style="height: 23px" v-else>&nbsp;</div>
          </div>
          <div class="lista-produto">
            <h4 class="h6 font-weight-bold mb-0">{{l.nome_produto}}</h4>
            <div class="badge badge-dark d-md-none" v-if="l.valor > 0">
              <span v-if="l.qtd_tabelas > 1 && l.valor > 0" style="font-size: 9px">A partir</span> {{l.valor | valor}}
            </div>
          </div>
        </a>
        <div class="rodape pb-2">
          <button class="btn btn-primary btn-sm mr-1 px-3" @click="adicionarProduto(l, true)" title="Adicionar produto diferente" v-show="l.divisao === '0'">
            <i class="fa fa-not-equal"></i>
          </button>
          <button class="btn btn-secondary btn-sm px-3" @click="adicionarProduto(l)" title="Adicionar produto">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ListaProdutos',
    props: ['produtos'],
    methods: {
      adicionarProduto(l, novo) {
        this.$emit('openProduto', l, novo)
      }
    }
  }
</script>

<style scoped>
  .lista {
    display: block;
    background-color: #fff;
    border: 1px solid #e9ecef;
    border-radius: 14px;
    margin-bottom: 12px;
    overflow: hidden;
  }

  .lista-body {
    color: var(--dark);
    text-decoration: none;
  }

  .lista-img {
    border-bottom: 1px solid #dee2e6;
    background-color: var(--primary);
  }

  .lista-img img {
    width: 100%;
    height: 80px;
    object-fit: cover;
  }

  .lista-img.bg-none {
    background: none;
  }

  .lista:focus {
    outline: 2px solid var(--primary);
  }

  .lista .h6 {
    font-size: 0.8rem
  }

  @media (min-width: 768px) {
    .lista {
      text-align: center;
    }

    .lista-produto {
      padding: 0 8px;
      margin-bottom: 12px;
      height: 32px;
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .lista-valor {
      margin-top: -14px;
      margin-bottom: 8px;
    }
  }

  @media (max-width: 767px) {
    .lista-body {
      padding: 12px 6px;
      display: flex;
      align-items: center;
    }

    .lista-img {
      border-bottom: 0;
      margin: 0 12px 0 6px;
      border-radius: 10px;
    }

    .lista-img img {
      width: 72px;
      height: 72px;
      border-radius: 10px;
    }

    .lista-valor {
      display: none;
    }

    .rodape {
      white-space: nowrap;
      display: none;
    }

    .lista .h6 {
      font-size: 0.9rem;
      font-weight: normal;
    }
  }
</style>
